/**
 * bootSkeleton — remove the index.html boot skeleton once the app is mounted.
 *
 * The skeleton (in index.html) fades in only after 150ms, so a fast load never
 * flashes it. On a slow load — notably the native shell's bundled->remote
 * re-navigation, which reloads the whole page and re-hydrates the SPA (~1s) — it
 * covers the touch-dead window so it reads as loading, not frozen. main.ts calls
 * this the moment the app shell is mounted and interactive.
 */
export function removeBootSkeleton(doc: Document = document): void {
  doc.getElementById("boot-skeleton")?.remove();
}
